import React, { Component } from 'react';
import AdminUsersView from '../views/AdminUsersView';
import { base } from '../../base';

class AdminUsersContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: null,
            companies: null,
        };
    }

    componentWillMount() {
        this.usersRef = base.syncState('users', {
            context: this,
            state: 'users',
            asArray: true,
        });

        this.companiesRef = base.syncState('companies', {
            context: this,
            state: 'companies',
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.usersRef);
        base.removeBinding(this.companiesRef);
    }

    render() {
        if (this.state.users != null && this.state.companies != null) {
            const users = this.state.users;
            for (let index = 0; index < users.length; index += 1) {
                const companyid = users[index].companyid;
                users[index].company = this.state.companies[companyid];
            }
            return (
                <AdminUsersView
                    users={users}
                />
            );
        }
        return (
            <span>
                Cargando
            </span>
        );
    }
}

export default AdminUsersContainer;



// WEBPACK FOOTER //
// ./src/components/containers/AdminUsersContainer.js